import { useTranslation } from "react-i18next";

import { CardModule } from "@/components/Layout/BaseLayouts/CardModule/CardModule";
import { PriceBreakdownTable } from "@/components/Portal/DeviceManagement/SubscriptionDetails/SubscriptionDisplay/SubscriptionPrice/PriceBreakdownTable";
import { useSubscriptionPriceBreakdown } from "@/components/Portal/DeviceManagement/SubscriptionDetails/SubscriptionDisplay/SubscriptionPrice/useSubscriptionPriceBreakdown";
import { SimCardDetail } from "@/services/model";

/**
 * "Subscription base price": what the subscription costs per period — base price,
 * discounts, and the add-ons (Watch SIM, Voice) listed below them.
 */
export const SubscriptionPrice = ({
  simDetail,
}: {
  simDetail: SimCardDetail;
}) => {
  const { t } = useTranslation("portal");
  const { t: tAbo } = useTranslation("portal", {
    keyPrefix: "cockpit.managementTile.subscription",
  });

  const breakdown = useSubscriptionPriceBreakdown(simDetail);

  const interval = simDetail.autoRenew
    ? t("cockpit.managementTile.tariff.payInterval", {
        days: simDetail.minContractDuration ?? 30,
      })
    : t("cockpit.managementTile.tariff.once");

  return (
    <CardModule
      dataTestid="subscription-price"
      title={tAbo("price.title")}
      bodyGap={2}
    >
      <PriceBreakdownTable
        breakdown={breakdown}
        interval={interval}
        collapseSingleRow
      />
    </CardModule>
  );
};
